import { Button } from '@material-ui/core';
import { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import { EventsTable } from "../../components/EventsTable";
import { TaskSearchBar } from "../../components/TaskSearchBar";

export const SentreeEvents = () => {
    const [filterText, setFilterText] = useState<string>("");

    return (
        <Fragment>
            <h1>Add New Events</h1>
            <Link to={"sentree/add"}>
                <Button variant="contained" color="primary">
                    Create
                </Button>
            </Link>
            <TaskSearchBar onNewFilterText={setFilterText}/>
            <h1>My Sentree Events to Review</h1>
            <EventsTable userOnly={true} taskType="Sentree" filterText={filterText}/>

            <h1>All Sentree Events to Review</h1>
            <EventsTable userOnly={false} taskType="Sentree" filterText={filterText}/>

            <h1>Tagged Sentree Events</h1>
            <EventsTable userOnly={false} getArchived={true} taskType="Sentree" filterText={filterText}/>
        </Fragment>
    )
}